import { c as _c } from "react/compiler-runtime";
import { Button, Modal, Radio, RadioGroup } from "@navikt/ds-react";
import Image from "next/image";
import { useEffect, useState } from "react";
import { ForhandsvarselTestScenario, getTestScenario, IkkeAktuellTestScenario, InfoSideTestScenario, InnstillingOmStansTestScenario, OppfyltTestScenario, setTestScenario, type TestScenario, UnntakTestScenario } from "@/utils/testScenarioUtils";
import SunImage from "../../../public/sun.svg";
import styles from "./testscenarioselector.module.css";
export const TestScenarioSelector = () => {
  const $ = _c(32);
  const [open, setOpen] = useState(false);
  const [selectedScenario, setSelectedScenario] = useState();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setSelectedScenario(getTestScenario());
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  if (!selectedScenario) {
    return null;
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setOpen(false);
    t3 = {
      heading: "Velg testscenario"
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t10;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = val => {
      setSelectedScenario(val);
    };
    t5 = <Radio value={InfoSideTestScenario}>Ny kandidat</Radio>;
    t6 = <Radio value={ForhandsvarselTestScenario}>Forhåndsvarsel</Radio>;
    t7 = <Radio value={IkkeAktuellTestScenario}>Ikke aktuell</Radio>;
    t8 = <Radio value={InnstillingOmStansTestScenario}>Innstilling om stans</Radio>;
    t9 = <Radio value={UnntakTestScenario}>Unntak</Radio>;
    t10 = <Radio value={OppfyltTestScenario}>Oppfylt</Radio>;
    $[4] = t10;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t10 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  let t11;
  if ($[11] !== selectedScenario) {
    t11 = <div className="mb-4"><RadioGroup legend="Velg testscenario" value={selectedScenario} hideLegend={true} onChange={t4}>{t5}{t6}{t7}{t8}{t9}{t10}</RadioGroup></div>;
    $[11] = selectedScenario;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== selectedScenario) {
    t12 = <Button id="VelgScenarioButton" variant="primary" onClick={() => {
      setTestScenario(selectedScenario);
      window.location.reload();
    }}>Velg scenario</Button>;
    $[13] = selectedScenario;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Button variant="tertiary" onClick={() => setOpen(false)}>Avbryt</Button>;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== t12) {
    t14 = <div>{t12}{t13}</div>;
    $[16] = t12;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  let t15;
  if ($[18] !== t11 || $[19] !== t14) {
    t15 = <Modal.Body>{t11}{t14}</Modal.Body>;
    $[18] = t11;
    $[19] = t14;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== open || $[22] !== t15) {
    t16 = <Modal open={open} aria-label="Testdatavelger" onClose={t2} header={t3}>{t15}</Modal>;
    $[21] = open;
    $[22] = t15;
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== open) {
    t17 = () => setOpen(!open);
    $[24] = open;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <Image src={SunImage} alt="" width={40} height={40} />;
    $[26] = t18;
  } else {
    t18 = $[26];
  }
  let t19;
  if ($[27] !== t17) {
    t19 = <button type="button" id="TestScenarioSelector" onClick={t17} className={styles.testscenariocontainer} aria-label={"\xC5pne testscenariovelger"}>{t18}</button>;
    $[27] = t17;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] !== t16 || $[30] !== t19) {
    t20 = <>{t16}{t19}</>;
    $[29] = t16;
    $[30] = t19;
    $[31] = t20;
  } else {
    t20 = $[31];
  }
  return t20;
};